module.exports = __webpack_public_path__ + "img/five.be5030ca.webp";